<template>
  <div class="hero">
      <img src="../assets/yuri.yeti.png" alt="Yuri the Yeti">
      <h1>Vue My Agents</h1>
  </div>
</template>

<style scoped>
div.hero {
  padding: 10px 0px;
  background-color: #2c3e50;
  border-bottom: solid 6px #42b983;
  display: flex;
  justify-content: center;
}

h1 {
  margin: 0;
  color: #fff;
  padding: 5px;
}

img {
  height: 42px;
  margin: 0px 15px;
  border-radius: 50%;
  border: 2px solid #42b983;
}
</style>
